<template>
  <div class="app-warpper">
    <template v-if="isShowLayout">
      <div class="header fixed-header">
        <nav-bar />
      </div>

      <el-scrollbar style="height: 100%" wrap-class="scrollbar-wrapper">
        <div class="main-container">
          <div class="base-warpper">
            <div class="children-container">
              <Sidebar v-show="isShowSidebar" />
              <div class="app-main" :class="isShowSidebar ? '' : 'full'">
                <Breadcrumb />

                <transition name="fade-transform" mode="out-in">
                  <router-view :key="key" :class="isShowSidebar ? 'has-aside-main-bg' : ''" />
                </transition>
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <el-backtop target=".el-scrollbar__wrap" :bottom="150" />
      </el-scrollbar>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { NavBar, Sidebar, Footer } from './components'
import Breadcrumb from '@/components/Breadcrumb'
import { mapGetters } from 'vuex'
export default {
  components: {
    NavBar,
    Sidebar,
    Breadcrumb,
    // eslint-disable-next-line vue/no-reserved-component-names
    Footer
  },
  data() {
    return {

      isShowLayout: true
    }
  },
  computed: {
    key() {
      return this.$route.path
    },
    ...mapGetters(['appConfig']),
    isShowSidebar() {
      if (this.$route.meta.isShowSidebar === undefined) {
        return true
      }
      return this.$route.meta.isShowSidebar
    }
  },
  created() {
    console.log(this.appConfig.theme_color, 777)
    document.documentElement.style.setProperty('--theme-color', this.appConfig.theme_color)
    const showType = this.$store.state.app.showType
    if (showType === 'h5') {
      this.isShowLayout = false
    }
  }
}
</script>

<style lang="scss" scoped>
.fixed-header{
	position: sticky;
    top: 0;
    z-index: 9;
}
</style>
